<script setup lang="ts">
import BaseHeader from '@/components/Headers/BaseHeader.vue'
import AD from '@/components/AD.vue'
import { computed, onMounted, watch } from 'vue'

import { useUserStore } from '@/stores/user'
import PromoPopup from '@/components/Popup/PromoPopup.vue'
import { useAuthStore } from '@/stores/auth'
import { ADV_IMAGE } from '@/helpers/globalVars'
const userStore = useUserStore()
const authStore = useAuthStore()

const currentTheme = computed(() => userStore.theme)
watch(currentTheme, () => {
  if (currentTheme.value) {
    const container = document.getElementById('app')
    if (container) {
      container.setAttribute('theme', currentTheme.value)
    }
  }
})

const isShowPromoPopup = computed(() => authStore.isShowPromoPopup)

onMounted(() => {
  userStore.getUserAsync()
  userStore.getThemeAsync()
})
</script>

<template>
<div class="default-layout">
  <transition name="fade">
    <PromoPopup v-if="!isAuth && isShowPromoPopup" />
  </transition>
  <div class="header">
    <BaseHeader />
  </div>
  <div class="content">
    <router-view/>
  </div>
  <div class="ad-hidden">
    <img
      class="img_hidden"
      :src="`/img/${ADV_IMAGE}`"
      :alt="ADV_IMAGE"/>
  </div>
  <div class="ad">
    <AD />
  </div>
</div>
</template>

<style lang="less" scoped>
.default-layout {
  display: flow-root;
}
.header {
  position: sticky;
  top: 0;
  z-index: 100;
}
.ad {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
.img_hidden {
  visibility: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-family: Unbounded;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
}
</style>
